module.exports = __webpack_public_path__ + "img/rachel-head.f9c24a5b.png";